import {Component, OnInit, AfterViewInit, Inject, OnDestroy} from '@angular/core';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import {ISubscription} from "rxjs/Subscription";
import {Http} from '@angular/http';
import {APP_CONFIG, AppConfig} from '../config/app.config.module';
import {SharedService} from '../common/shared.service';
import {TopnavService} from '../header/topnav/topnav.service';
import {SafeHtmlPipe} from '../pipe/safe-html.pipe';
import {ActivatedRoute} from '@angular/router';

/**
 * Author: Sridhar Swaminathan
 *
 * Date Created: November 14th 2017
 *
 * Description: Component class for Life Event content.
 **/
@Component({
  selector: 'app-lifeevent',
  templateUrl: './lifeevent.component.html',
  styleUrls: ['./lifeevent.component.css'],
  providers: [SafeHtmlPipe]
})
export class LifeeventComponent implements OnInit, AfterViewInit, OnDestroy {
  fontName: string = 'Arial';
  lifeEventDesc: any;
  lifeEventTitle: any;
  lifeEventData: any[];
  lang = 'en';
  languageId; //= this.languageId;
  private subscription: ISubscription;
  private subscriptionLang: ISubscription;
  public subscriptionFontType: ISubscription;
  public fontType: string = 'Arial';
  private subscriptionFontSize: ISubscription;
  public fontSize: any = {
    "sizeS": "14px",
    "sizeM": "19px",
    "sizeL": "23px",
    "no_styles": "0.9em"
  };

  public myflag: any;

  private isInitialized: boolean = false;

  constructor(private activatedRoute: ActivatedRoute, public safeHtml: SafeHtmlPipe, private translate: TranslateService, private topnavservice: TopnavService, private http: Http, @Inject(APP_CONFIG) private config: AppConfig, private sharedService: SharedService) {
    this.subscriptionLang = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      // this.sharedService.errorHandling(event, (function(){
      const myLang = this.translate.currentLang;
      if (myLang === 'en') {
        this.lang = 'en';
        this.languageId = 1;
      }
      if (myLang === 'ms') {
        this.lang = 'ms';
        this.languageId = 2;
      }

      if (this.topnavservice.flagLang && this.isInitialized) {
        this.subscription = this.getData(this.languageId);
      }

    });

    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data) => {
      this.fontSize = data;
      $('.mat-tab-label').css('font-size', this.fontSize.sizeS);
      $('.mat-tab-link').css('font-size', this.fontSize.sizeS);
    });

    this.subscriptionFontType = this.sharedService.fontTypeData.subscribe((data) => {
      this.fontType = data;
      $('.mat-tab-label').css('font-family', this.fontType);
      $('.mat-tab-link').css('font-family', this.fontType);
    });

    this.activatedRoute.queryParams.subscribe(params => {
      let lng = params['language'];
      if (lng && lng.toLowerCase() == 'my') {
        this.myflag = {language: "my"};
      } else {
        this.myflag = null;
      }
    });
  }

  ngOnDestroy() {
    this.subscriptionLang.unsubscribe();
    this.subscription.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
    this.subscriptionFontType.unsubscribe();
  }

  ngOnInit() {

    if (!this.languageId) {
      if (localStorage.getItem('langID')) {
        this.languageId = localStorage.getItem('langID');
      } else {
        this.languageId = 1;
      }
    }
    this.subscription = this.getData(this.languageId);
  }

  ngAfterViewInit() {
    this.fontName = localStorage.getItem('customFontType');
    if (this.fontName) {
      $('.mat-tab-label').css('font-family', this.fontName);
      $('.mat-tab-link').css('font-family', this.fontName);
    }
    this.sharedService.loadFontSizeData();
    this.sharedService.loadFontTypeData();
  }

  refreshFonts() {
    //alert('test');
    this.sharedService.loadFontSizeData();
    this.sharedService.loadFontTypeData();
  }

  private lifeEventUrl: string = 'life/event';

  getData(lang: string) {

    return this.sharedService.readPortal(this.lifeEventUrl, '', '', '', lang)
      .subscribe(resSliderData => {
        this.lifeEventTitle = resSliderData['contentCategoryName'];
        this.lifeEventDesc = resSliderData['contentCategoryDescription'];
        this.lifeEventData = resSliderData['contentCategoryResourceList'];
        setTimeout(() => {
          this.isInitialized = true;
        })
      });
  }

  getTheme() {
    return localStorage.getItem('themeColor');
  }

}



// WEBPACK FOOTER //
// ./src/app/lifeevent/lifeevent.component.ts